var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.showHeader)?_c('NavBar',{on:{"onLoginClick":_vm.openAuth}}):_vm._e(),_c('AuthModal',{ref:"authModal"}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }